import { useMatch, useNavigate } from "@solidjs/router";
import { IntrinsicNodeProps, ElementNode } from "@solidtv/solid";
import { Column } from "@solidtv/solid/primitives";
import styles from "./NavDrawer.styles";
import { createMemo } from "solid-js";
import Icon from "../Icon";
import theme from "theme";

interface NavButtonProps extends IntrinsicNodeProps {
  icon: string;
  iconColor: string;
  children: string;
}

const NavButtonTextStyles = {
  x: 112,
  fontSize: 38,
  lineHeight: 70,
  alpha: 0,
  color: theme.textPrimary,
  $active: {
    alpha: 1
  }
} as const;

function NavButton(props: NavButtonProps) {
  return (
    <view {...props} forwardStates style={styles.NavButton}>
      <view y={-16}>
        <Icon color={props.iconColor} scale={0.5} name={props.icon} />
      </view>
      <text style={NavButtonTextStyles}>{props.children}</text>
    </view>
  );
}

export default function NavDrawer(props) {
  let backdrop: ElementNode | undefined;
  const navigate = useNavigate();
  function onFocus(this: ElementNode) {
    backdrop!.states.add("$focus");
    this.children.forEach((c) => c.states!.add("$active"));
    this.children[this.selected || 0].setFocus();
  }

  function onBlur(this: ElementNode) {
    backdrop!.states.remove("$focus");
    this.selected = 0;
    this.children.forEach((c) => c.states!.remove("$active"));
  }

  function handleNavigate(page: string) {
    const isOnPage = useMatch(() => page);
    if (isOnPage()) {
      return props.focusPage();
    }

    navigate(page);
  }

  const selectedButton = createMemo(() => {
    if (useMatch(() => "/home")()) return 366;
    if (useMatch(() => "/live")()) return 462;
    return 366;
  });

  return (
    <>
      <view
        id="NavDrawer"
        flexItem={false}
        width={300}
        height={100}
        x={30}
        y={15}
        zIndex={105}
        alpha={props.showWidgets ? 1 : 0}
      >
        <text y={8} x={10} fontSize={32} fontWeight={"bold"} color={theme.textPrimary}>
          CHEK+
        </text>
      </view>
      <Column {...props} onFocus={onFocus} onBlur={onBlur} style={styles.Column} announce={"Main Menu"} scroll="none">
        <NavButton
          onEnter={() => handleNavigate("/home")}
          iconColor={"#fff"}
          announce={["Home", "button"]}
          icon="home"
        >
          Home
        </NavButton>
        <NavButton
          icon="tv"
          iconColor={"#fff"}
          announce={["24/7 Livestream", "button"]}
          onEnter={() => handleNavigate("/live")}
        >
          Live
        </NavButton>
      </Column>
      <view skipFocus ref={backdrop} style={styles.Gradient} />
      <view width={4} height={56} color={"#FFF"} x={22} y={selectedButton()} zIndex={100} />
    </>
  );
}

